<div class="plugin-section">
  <div class="plugin-top-bar">
    <div class="plugin-title">
      <img [src]="plugin.logoUrl" style="width: 16px; height: 16px; margin-right: 10px" alt="Plugin logo" />
      <h3 class="plugin-title-text">{{ plugin.title }}</h3>
    </div>
  </div>
</div>
<iframe [title]="plugin.title" [id]="pluginId" [src]="src" [plugin]="plugin" tabindex="-1" allow="none" style="border: none; height: 450px; width: 100%" pluginOnLoad></iframe>
